export default () => {
  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.js-hero')) {
      document.body.classList.add('hero-exists')
    }
  })
}
